import { clearFetch } from '../vodjs/Utils.js';
import { getConfig } from './configUtils';
import { elasticLogEvent } from '../vodjs/ElasticLog.js';

const options = {
  method: 'GET',
  headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
};

interface KioskSettings {
  id: string;
  name: string;
  value: boolean;
}

interface Kiosk {
  id: string;
  name: string;
  friendlyName: string;
  siteId: string;
  settings: KioskSettings[];
}

async function getKioskSettings(siteName: string) {
  let multibotBackendUrl = getConfig().uiSimServer;
  let settings;

  const url = new URL(`sites/${siteName}/settings`, multibotBackendUrl);
  await clearFetch(url, options, {
    success: (json: Kiosk[]) => (settings = json),
    bad: ({ logStr }: { logStr: string }) => console.log('ERROR getting kiosk settings: ', logStr),
  });

  return settings;
}

function getSettingValue(kiosk: Kiosk, name: string) {
  if (kiosk && kiosk.settings) {
    const setting = kiosk.settings.find((s) => s.name === name);

    if (setting) {
      return setting.value;
    } else {
      elasticLogEvent({ what: 'kioskSettings', msg: `Kiosk setting named ${name} was not found` });
    }
  }
}

export { getKioskSettings, getSettingValue };
